import { Box } from '@wix/design-system';
import { DateAndTime, Email, IconProps, Phone, Revert, WixChat } from '@wix/wix-ui-icons-common';
import React, { FC } from 'react';

import { CommunityIcon } from './CommunityIcon';

const ICONS_COMPONENT: Record<string, FC<IconProps>> = {
  chat: WixChat,
  phone: Phone,
  ticket: Email,
  schedule: DateAndTime,
  community: CommunityIcon,
  restart: Revert,
};

type ButtonIconProps = {
  icon?: string;
};

export const ButtonIcon: FC<ButtonIconProps> = ({ icon }) => {
  const IconComponent = icon && ICONS_COMPONENT[icon];

  if (!IconComponent) {
    return null;
  }

  return (
    <Box key="icon" dataHook="icon" verticalAlign="middle" color="B10">
      <IconComponent size={24} />
    </Box>
  );
};
